import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const GET_SCAN_FOLDER_CONTENT_REQUEST = NS + 'GET_SCAN_FOLDER_CONTENT_REQUEST'
export const GET_SCAN_FOLDER_CONTENT_SUCCESS = NS + 'GET_SCAN_FOLDER_CONTENT_SUCCESS'
export const GET_SCAN_FOLDER_CONTENT_ERROR = NS + 'GET_SCAN_FOLDER_CONTENT_ERROR'




// WEBPACK FOOTER //
// ./src/modules/customer/state/transfer-drive-files/type.js